export default "__VITE_ASSET__CeumU8tH__"